// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AgentTableController from "./agent_table_controller"
application.register("agent-table", AgentTableController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LockedSubmitController from "./locked_submit_controller"
application.register("locked-submit", LockedSubmitController)

import PaypalController from "./paypal_controller"
application.register("paypal", PaypalController)

import PhoneController from "./phone_controller"
application.register("phone", PhoneController)

import RadioToggleController from "./radio_toggle_controller"
application.register("radio-toggle", RadioToggleController)

import RecruiterController from "./recruiter_controller"
application.register("recruiter", RecruiterController)

import SearchFormController from "./search_form_controller"
application.register("search-form", SearchFormController)

import SelectToggleController from "./select_toggle_controller"
application.register("select-toggle", SelectToggleController)

import SlimRemoteController from "./slim_remote_controller"
application.register("slim-remote", SlimRemoteController)

import SsnFormatterController from "./ssn_formatter_controller"
application.register("ssn-formatter", SsnFormatterController)

import ZipController from "./zip_controller"
application.register("zip", ZipController)

import RevealController from '@stimulus-components/reveal'
application.register('reveal', RevealController)